import { ImagePreviewType } from "@nova/constants"
import { MapPortalContext } from "features/map/layers/MapPortalContext"
import { selectImagePreviewContext } from "features/map/layers/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { ColorfinderImagePreviewModal } from "plugins/ColorFinder/ImageColorFinder/ImageColorFinderMultifileUpload"
import { InfraredImagePreviewModal } from "plugins/InfraredImage/InfraredImageMultifileUpload"
import { OrthoImagePreviewModal } from "plugins/Orthomosaic/OrthomosaicMultifileUpload"
import { PDFPreviewModalWithBoundary } from "plugins/PDFv2/PDFPreviewModal"
import { FC, useCallback, useContext, useEffect } from "react"
import { ImagePreviewContainer } from "./ImagePreviewContainer"

export const ImagePreviewModalV2 = () => {
    const previewModalContext = useAppSelector(selectImagePreviewContext())
    const { register, unregister } = useContext(MapPortalContext)

    const type = previewModalContext?.type
    let Component: FC | undefined

    switch (type) {
        case ImagePreviewType.Ortho:
            Component = OrthoImagePreviewModal
            break
        case ImagePreviewType.Infrared:
            Component = InfraredImagePreviewModal
            break
        case ImagePreviewType.Colorfinder:
            Component = ColorfinderImagePreviewModal
            break
        case ImagePreviewType.PDF:
            Component = PDFPreviewModalWithBoundary
            break
    }

    const RealComponent = useCallback(
        () => (
            <>
                {Component && (
                    <ImagePreviewContainer>
                        <Component />
                    </ImagePreviewContainer>
                )}
            </>
        ),
        [Component]
    )
    useEffect(() => {
        const activeType = type
        if (activeType && RealComponent) register(activeType, RealComponent)
        return () => {
            if (activeType) unregister(activeType)
        }
    }, [RealComponent, register, type, unregister])

    return null
}

ImagePreviewModalV2.displayName = "ImagePreviewModal"
